// Product card color swatches: hovering (or focusing) a swatch swaps the card's
// main image to that color's first image and points the card links at that color.
// Leaving the card restores the original image and links.
// Loaded as a module, so it runs once per page no matter how many cards include it.

const SWATCH = '.card-swatches__item';
const CARD = '.card-wrapper';

const getImg = (card) => card.querySelector('.card__inner .card__media .media img');
const getLinks = (card) =>
  card.querySelectorAll('a[id^="CardLink-"], a[id^="StandardCardNoMediaLink-"]');

function remember(card) {
  if (card._swatchOrig) return;
  const img = getImg(card);
  card._swatchOrig = {
    src: img ? img.getAttribute('src') : null,
    srcset: img ? img.getAttribute('srcset') : null,
    links: [...getLinks(card)].map((a) => [a, a.getAttribute('href')]),
  };
}

function setActive(card, swatch) {
  card.querySelectorAll(SWATCH + '.is-active').forEach((el) => el.classList.remove('is-active'));
  if (swatch) swatch.classList.add('is-active');
}

function show(swatch) {
  const card = swatch.closest(CARD);
  if (!card) return;
  remember(card);
  const img = getImg(card);
  const src = swatch.dataset.swatchSrc;
  if (img && src && img.getAttribute('src') !== src) {
    img.setAttribute('srcset', swatch.dataset.swatchSrcset || src);
    img.setAttribute('src', src);
  }
  getLinks(card).forEach((a) => a.setAttribute('href', swatch.getAttribute('href')));
  setActive(card, swatch);
}

function restore(card) {
  const orig = card._swatchOrig;
  if (!orig) return;
  const img = getImg(card);
  if (img && orig.src) {
    if (orig.srcset) img.setAttribute('srcset', orig.srcset);
    else img.removeAttribute('srcset');
    img.setAttribute('src', orig.src);
  }
  orig.links.forEach(([a, href]) => a.setAttribute('href', href));
  setActive(card, null);
}

function preload(card) {
  if (card._swatchPreloaded) return;
  card._swatchPreloaded = true;
  const sizes = getImg(card)?.getAttribute('sizes') || '';
  card.querySelectorAll(SWATCH + '[data-swatch-src]').forEach((swatch) => {
    const pre = new Image();
    pre.sizes = sizes;
    if (swatch.dataset.swatchSrcset) pre.srcset = swatch.dataset.swatchSrcset;
    pre.src = swatch.dataset.swatchSrc;
  });
}

document.addEventListener('pointerover', (event) => {
  if (event.pointerType === 'touch') return;
  const target = event.target instanceof Element ? event.target : null;
  if (!target) return;
  const swatch = target.closest(SWATCH + '[data-swatch-src]');
  if (swatch) {
    show(swatch);
    return;
  }
  const card = target.closest(CARD);
  if (card && card.querySelector(SWATCH + '[data-swatch-src]')) preload(card);
});

document.addEventListener('pointerout', (event) => {
  const target = event.target instanceof Element ? event.target : null;
  const card = target && target.closest(CARD);
  if (!card || !card._swatchOrig) return;
  if (event.relatedTarget && card.contains(event.relatedTarget)) return;
  restore(card);
});

document.addEventListener('focusin', (event) => {
  const target = event.target instanceof Element ? event.target : null;
  const swatch = target && target.closest(SWATCH + '[data-swatch-src]');
  if (swatch) show(swatch);
});

document.addEventListener('focusout', (event) => {
  const target = event.target instanceof Element ? event.target : null;
  const card = target && target.closest(CARD);
  if (!card || !card._swatchOrig) return;
  if (event.relatedTarget && card.contains(event.relatedTarget)) return;
  restore(card);
});
